import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';

@Directive({
  selector: '[ngTemplateType]',
  standalone: true,
})
export class NgTemplateAssertType<T> {
  public static ngTemplateContextGuard<T>(dir: NgTemplateAssertType<T>, ctx: any): ctx is T {
    return true;
  }

  private readonly _templateRef = inject<TemplateRef<T>>(TemplateRef);
  private readonly _viewContainer = inject(ViewContainerRef);

  @Input() public ngTemplateType: T;
}

@Directive({
  selector: '[ngTemplateNarrowType]',
  standalone: true,
})
export class NgTemplateSwitchType<T = unknown> {
  public static ngTemplateGuard_ngTemplateNarrowType: 'binding';
  public static ngTemplateContextGuard<T>(dir: NgTemplateSwitchType<T>, ctx: any): ctx is T {
    return true;
  }

  private readonly _viewContainer = inject(ViewContainerRef);
  private readonly templateRef = inject<TemplateRef<T>>(TemplateRef);

  @Input() public ngTemplateNarrowType: T;
}
